import { Controller } from 'stimulus';
let debounce = require('lodash/debounce');

export default class extends Controller {
  static targets = ["query"];

  initialize() {
    this.search = debounce(this.search, 500).bind(this);
  }

  connect() {
    console.log("hello from StimulusJS")
  }

  search() {
    // let query = this.element.querySelector('input').value;
    let query = this.queryTarget.value;
    console.log(query);
    if (this.isImei(query)) {
      console.log('imei');
      this.getProductsbyImei(query);
      document.getElementById('loading-wrapper').style = '';
      //this.searchImei(query);
    }
  }

  getProductsbyImei(imei) {
    let url = `/search?q=${imei}&imei=true`;
    fetch(url)
      .then(response => {
        console.log(response.text());
        document.doEval(response.text);
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        document.getElementById('loading-wrapper').style = 'display: none';
      }
      );
  }

  isImei(s) {
    var etal = /^[0-9]{15}$/;

    if (!etal.test(s))
      return false;

    let sum = 0;
    let mul = 2;
    let l = 14;
    for (let i = 0; i < l; i++) {
      let digit = s.substring(l - i - 1, l - i);
      let tp = parseInt(digit, 10) * mul;
      if (tp >= 10)
        sum += (tp % 10) + 1;
      else
        sum += tp;
      if (mul == 1)
        mul++;
      else
        mul--;
    }
    let chk = ((10 - (sum % 10)) % 10);

    if (chk != parseInt(s.substring(14, 15), 10))
      return false;

    return true;
  }
}